<template>
  <div>
    <div class="toolbar toolbar-between">
      <span class="title">{{ title }}</span>
      <div>
        <crm-owner-transfer v-if="['lead', 'customer', 'pool'].includes(kind)" @changed="load" />
        <crm-pool-settings v-if="kind === 'pool'" @changed="load" />
        <el-input v-if="showKeyword" v-model="keyword" size="small" clearable placeholder="搜索名称/电话" style="width:200px;margin-right:8px" @keyup.enter.native="load" />
        <el-button v-if="showKeyword" size="small" @click="load">查询</el-button>
        <el-button v-if="kind !== 'pool'" type="primary" size="small" icon="el-icon-plus" @click="open()">新增</el-button>
      </div>
    </div>

    <el-alert v-if="activeFilter" :title="activeFilter" type="info" :closable="false" style="margin-bottom:12px">
      <el-button type="text" @click="$router.replace({path:$route.path})">清除筛选</el-button>
    </el-alert>

    <template v-if="kind === 'pool'">
      <h4>线索公海</h4>
      <el-table :data="poolLeads" border v-loading="loading">
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="phone" label="电话" />
        <el-table-column prop="companyName" label="公司" />
        <el-table-column prop="source" label="来源" />
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="act('claimLead', row)">领取</el-button>
          </template>
        </el-table-column>
      </el-table>
      <h4 style="margin-top:16px">客户公海</h4>
      <el-table :data="poolCustomers" border>
        <el-table-column prop="name" label="客户" />
        <el-table-column prop="industry" label="行业" />
        <el-table-column prop="tier" label="等级" />
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="act('claimCustomer', row)">领取</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <el-table v-else :data="rows" border v-loading="loading">
      <el-table-column v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label" :min-width="col.width || 120" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ showCell(row, col) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="['lead', 'customer', 'deal', 'contract'].includes(kind)" type="text" @click="$router.push('/crm/detail/' + kind + '/' + row.id)">详情</el-button>
          <crm-order-generate v-if="kind === 'contract'" :contract="row" @generated="load" />
          <crm-duplicates v-if="['lead', 'customer'].includes(kind)" :kind="kind" :record="row" @merged="load" />
          <el-button v-if="kind !== 'approval' || row.bizType !== 'QUOTE'" type="text" @click="open(row)">{{ kind==='activity' || (kind==='payment' && row.status==='PAID') || (kind==='approval' && row.status!=='PENDING')?'查看':'编辑' }}</el-button>
          <el-button v-if="kind === 'approval' && row.bizType === 'QUOTE'" type="text" @click="$router.push({path:'/crm/quote',query:{quoteId:row.bizId}})">查看报价</el-button>
          <el-button v-if="kind === 'lead' && row.status!=='CONVERTED'" type="text" @click="act('releaseLead', row)">放入公海</el-button>
          <el-button v-if="kind === 'lead' && row.status!=='CONVERTED'" type="text" @click="act('convertLead', row)">转商机</el-button>
          <el-button v-if="kind === 'customer'" type="text" @click="act('releaseCustomer', row)">放入公海</el-button>
          <el-button v-if="kind === 'approval' && canApprove && row.status === 'PENDING'" type="text" @click="decide(row, 'APPROVED')">通过</el-button>
          <el-button v-if="kind === 'approval' && canApprove && row.status === 'PENDING'" type="text" @click="decide(row, 'REJECTED')">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="readonlyActivity?'查看跟进记录':(kind==='payment' && readonlyPayment ? '查看回款记录' : (kind==='approval' && readonlyApproval?'查看审批记录':(form.id ? '编辑' : (kind==='approval'?'新增合同审批':'新增'))))" :visible.sync="visible" width="520px" custom-class="crm-record-dialog">
      <el-form :model="form" label-width="100px" :disabled="readonlyActivity || (kind==='payment' && readonlyPayment) || (kind==='approval' && readonlyApproval)">
        <el-form-item v-for="f in fields" :key="f.prop" :label="f.label">
          <el-input-number v-if="f.type === 'number'" v-model="form[f.prop]" :min="0" :max="f.max" :precision="f.precision" style="width:100%" />
          <el-date-picker v-else-if="f.type === 'date'" v-model="form[f.prop]" :clearable="kind!=='payment' || f.prop==='paidAt'" type="date" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
          <el-date-picker v-else-if="f.type === 'datetime'" v-model="form[f.prop]" :clearable="!form.id" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
          <el-select v-else-if="f.type === 'select'" v-model="form[f.prop]" :disabled="!!f.disabled" :filterable="!!f.filterable" :clearable="!!f.clearable" style="width:100%" @change="selectionChanged(f)">
            <el-option v-for="op in f.options" :key="op.value" :label="op.label" :value="op.value" :disabled="!!op.disabled" />
          </el-select>
          <el-input v-else v-model="form[f.prop]" :type="f.type==='textarea'?'textarea':'text'" :rows="f.type==='textarea'?4:undefined" :maxlength="f.maxlength" :show-word-limit="!!f.maxlength" :disabled="!!f.disabled" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <crm-duplicates v-if="['lead', 'customer'].includes(kind)" :kind="kind" :record="form" @merged="visible=false; load()" />
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="!readonlyActivity && (kind!=='payment' || !readonlyPayment) && (kind!=='approval' || !readonlyApproval)" type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { crm } from '../../api/crm'
import CrmDuplicates from '../../components/CrmDuplicates.vue'
import CrmOwnerTransfer from '../../components/CrmOwnerTransfer.vue'
import CrmPoolSettings from '../../components/CrmPoolSettings.vue'
import CrmOrderGenerate from '../../components/CrmOrderGenerate.vue'
import { effectivePaymentStatus, paymentStatusLabel } from '../../utils/crmPaymentStatus'

const LEAD_STATUS = [
  { value: 'NEW', label: '新建' },
  { value: 'NURTURE', label: '培育' },
  { value: 'POOL', label: '公海' },
  { value: 'CONVERTED', label: '已转化' },
  { value: 'CLOSED', label: '关闭' }
]
const DEAL_STAGE = [
  { value: 'CONTACT', label: '接触' },
  { value: 'DISCOVERY', label: '需求' },
  { value: 'PROPOSAL', label: '方案' },
  { value: 'WON', label: '赢单' },
  { value: 'LOST', label: '丢单' }
]
const QUOTE_STATUS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'APPROVING', label: '审批中' },
  { value: 'APPROVED', label: '已通过' },
  { value: 'REJECTED', label: '已驳回' }
]
const CONTRACT_STATUS = [
  { value: 'ACTIVE', label: '履行中' },
  { value: 'RENEWING', label: '续约中' },
  { value: 'EXPIRED', label: '已到期' }
]
const PAY_STATUS = [
  { value: 'PENDING', label: '待回款' },
  { value: 'PAID', label: '已回款' },
  { value: 'OVERDUE', label: '逾期' }
]
const APPROVAL_STATUS = [
  { value: 'PENDING', label: '待审' },
  { value: 'APPROVED', label: '通过' },
  { value: 'REJECTED', label: '驳回' }
]
const TASK_STATUS = [
  { value: 'OPEN', label: '待办' },
  { value: 'DONE', label: '完成' }
]
const OBJECTS = [
  { value: 'LEAD', label: '线索' },
  { value: 'CUSTOMER', label: '客户' },
  { value: 'DEAL', label: '商机' },
  { value: 'CONTRACT', label: '合同' }
]
const CHANNELS = [
  { value: 'CALL', label: '通话' },
  { value: 'WECOM', label: '企微' },
  { value: 'NOTE', label: '备注' }
]

function labelOf(options, value) {
  const hit = (options || []).find(o => o.value === value)
  return hit ? hit.label : (value == null ? '' : value)
}

const SPECS = {
  lead: {
    columns: [
      { prop: 'name', label: '姓名' },
      { prop: 'phone', label: '电话' },
      { prop: 'companyName', label: '公司' },
      { prop: 'source', label: '来源' },
      { prop: 'status', label: '状态', options: LEAD_STATUS },
      { prop: 'intentLevel', label: '意向' }
    ],
    fields: [
      { prop: 'name', label: '姓名', maxlength:128 },
      { prop: 'phone', label: '电话', maxlength:32 },
      { prop: 'companyName', label: '公司', maxlength:128 },
      { prop: 'source', label: '来源', maxlength:64 },
      { prop: 'status', label: '状态', type: 'select', options: LEAD_STATUS },
      { prop: 'intentLevel', label: '意向', maxlength:16 },
      { prop: 'remark', label: '备注', type:'textarea', maxlength:500 }
    ],
    load: () => crm.leads({ inPool: 0 }),
    save: data => crm.saveLead(data)
  },
  customer: {
    columns: [
      { prop: 'name', label: '客户' },
      { prop: 'phone', label: '电话' },
      { prop: 'industry', label: '行业' },
      { prop: 'tier', label: '等级' },
      { prop: 'yearAmount', label: '年成交额' },
      { prop: 'healthScore', label: '健康度' }
    ],
    fields: [
      { prop: 'name', label: '客户', maxlength:128 },
      { prop: 'phone', label: '电话', maxlength:32 },
      { prop: 'industry', label: '行业', maxlength:64 },
      { prop: 'tier', label: '等级', maxlength:32 },
      { prop: 'address', label: '地址', maxlength:255 },
      { prop: 'remark', label: '备注', type:'textarea', maxlength:500 }
    ],
    load: () => crm.customers({ inPool: 0 }),
    save: data => crm.saveCustomer(data)
  },
  contact: {
    columns: [
      { prop: 'customerId', label: '客户' },
      { prop: 'name', label: '姓名' },
      { prop: 'title', label: '职务' },
      { prop: 'phone', label: '电话' },
      { prop: 'roleType', label: '角色' }
    ],
    fields: [
      { prop: 'customerId', label: '客户', type: 'select' },
      { prop: 'name', label: '姓名', maxlength:64 },
      { prop: 'title', label: '职务', maxlength:64 },
      { prop: 'phone', label: '电话', maxlength:32 },
      { prop: 'roleType', label: '角色', maxlength:32 }
    ],
    load: () => crm.contacts(),
    save: data => crm.saveContact(data)
  },
  deal: {
    columns: [
      { prop: 'title', label: '商机' },
      { prop: 'customerId', label: '客户' },
      { prop: 'stage', label: '阶段', options: DEAL_STAGE },
      { prop: 'amount', label: '金额' },
      { prop: 'winRate', label: '赢率%' }
    ],
    fields: [
      { prop: 'title', label: '商机', maxlength:128 },
      { prop: 'customerId', label: '客户', type: 'select' },
      { prop: 'stage', label: '阶段', type: 'select', options: DEAL_STAGE },
      { prop: 'amount', label: '金额' },
      { prop: 'winRate', label: '赢率', type: 'number', max:100, precision:0 },
      { prop: 'competitor', label: '竞品', maxlength:128 },
      { prop: 'remark', label: '备注', type:'textarea', maxlength:500 }
    ],
    load: () => crm.deals(),
    save: data => crm.saveDeal(data)
  },
  quote: {
    columns: [
      { prop: 'quoteNo', label: '单号' },
      { prop: 'dealId', label: '商机ID' },
      { prop: 'amount', label: '金额' },
      { prop: 'discount', label: '折扣' },
      { prop: 'status', label: '状态', options: QUOTE_STATUS }
    ],
    fields: [
      { prop: 'dealId', label: '商机ID', type: 'number' },
      { prop: 'customerId', label: '客户ID', type: 'number' },
      { prop: 'amount', label: '金额' },
      { prop: 'discount', label: '折扣' },
      { prop: 'status', label: '状态', type: 'select', options: QUOTE_STATUS },
      { prop: 'remark', label: '备注' }
    ],
    load: () => crm.quotes(),
    save: data => crm.saveQuote(data)
  },
  contract: {
    columns: [
      { prop: 'contractNo', label: '合同号' },
      { prop: 'title', label: '标题' },
      { prop: 'customerId', label: '客户' },
      { prop: 'dealId', label: '商机' },
      { prop: 'amount', label: '金额' },
      { prop: 'status', label: '状态', options: CONTRACT_STATUS }
    ],
    fields: [
      { prop: 'title', label: '标题' },
      { prop: 'customerId', label: '客户', type: 'select' },
      { prop: 'dealId', label: '商机（可选）', type: 'select' },
      { prop: 'amount', label: '金额' },
      { prop: 'startAt', label: '生效日期', type: 'date' },
      { prop: 'endAt', label: '到期日期', type: 'date' },
      { prop: 'status', label: '状态', type: 'select', options: CONTRACT_STATUS },
      { prop: 'remark', label: '备注' }
    ],
    load: () => crm.contracts(),
    save: data => crm.saveContract(data)
  },
  payment: {
    columns: [
      { prop: 'contractId', label: '合同' },
      { prop: 'periodName', label: '期次' },
      { prop: 'amount', label: '金额' },
      { prop: 'dueAt', label: '到期日期' },
      { prop: 'paidAt', label: '实际回款日期' },
      { prop: 'status', label: '状态', options: PAY_STATUS }
    ],
    fields: [
      { prop: 'contractId', label: '合同', type: 'select' },
      { prop: 'periodName', label: '期次' },
      { prop: 'amount', label: '金额' },
      { prop: 'dueAt', label: '到期日期', type: 'date' },
      { prop: 'paidAt', label: '实际回款日期', type: 'date' },
      { prop: 'status', label: '状态', type: 'select', options: PAY_STATUS }
    ],
    load: () => crm.payments(),
    save: data => crm.savePayment(data)
  },
  approval: {
    columns: [
      { prop: 'title', label: '标题' },
      { prop: 'bizType', label: '类型', options: [{value:'CONTRACT',label:'合同'},{value:'QUOTE',label:'报价'}] },
      { prop: 'bizId', label: '关联单据' },
      { prop: 'status', label: '状态', options: APPROVAL_STATUS },
      { prop: 'summary', label: '摘要' },
      { prop: 'comment', label: '审批意见' },
      { prop: 'decidedAt', label: '处理时间' }
    ],
    fields: [
      { prop: 'title', label: '标题' },
      { prop: 'bizType', label: '类型', type: 'select', options: [{ value: 'CONTRACT', label: '合同' }] },
      { prop: 'bizId', label: '合同', type: 'select' },
      { prop: 'summary', label: '摘要' }
    ],
    load: () => crm.approvals(),
    save: data => crm.saveApproval(data)
  },
  task: {
    columns: [
      { prop: 'title', label: '提醒' },
      { prop: 'taskType', label: '类型' },
      { prop: 'status', label: '状态', options: TASK_STATUS },
      { prop: 'dueAt', label: '到期时间' },
      { prop: 'bizType', label: '对象', options: OBJECTS },
      { prop: 'bizId', label: '关联记录' }
    ],
    fields: [
      { prop: 'title', label: '提醒' },
      { prop: 'taskType', label: '类型' },
      { prop: 'status', label: '状态', type: 'select', options: TASK_STATUS },
      { prop: 'dueAt', label: '到期时间', type: 'datetime' },
      { prop: 'bizType', label: '对象', type: 'select', options: OBJECTS },
      { prop: 'bizId', label: '关联记录', type: 'select' }
    ],
    load: () => crm.tasks(),
    save: data => crm.saveTask(data)
  },
  activity: {
    columns: [
      { prop: 'bizType', label: '对象', options: OBJECTS },
      { prop: 'bizId', label: '关联记录' },
      { prop: 'channel', label: '渠道', options: CHANNELS },
      { prop: 'content', label: '内容' },
      { prop: 'createdAt', label: '记录时间' }
    ],
    fields: [
      { prop: 'bizType', label: '对象', type: 'select', options: OBJECTS },
      { prop: 'bizId', label: '关联记录', type: 'select' },
      { prop: 'channel', label: '渠道', type: 'select', options: CHANNELS },
      { prop: 'content', label: '内容', type: 'textarea', maxlength:1000 }
    ],
    load: () => crm.activities(),
    save: data => crm.saveActivity(data)
  },
  field: {
    columns: [
      { prop: 'objectType', label: '对象', options: OBJECTS },
      { prop: 'fieldKey', label: '字段键' },
      { prop: 'fieldLabel', label: '显示名' },
      { prop: 'fieldType', label: '类型' },
      { prop: 'enabled', label: '启用' }
    ],
    fields: [
      { prop: 'objectType', label: '对象', type: 'select', options: OBJECTS },
      { prop: 'fieldKey', label: '字段键' },
      { prop: 'fieldLabel', label: '显示名' },
      { prop: 'fieldType', label: '类型', type: 'select', options: [
        { value: 'TEXT', label: '文本' },
        { value: 'NUMBER', label: '数字' },
        { value: 'DATE', label: '日期' }
      ] },
      { prop: 'requiredFlag', label: '必填', type: 'select', options: [{ value: 0, label: '否' }, { value: 1, label: '是' }] },
      { prop: 'enabled', label: '启用', type: 'select', options: [{ value: 1, label: '启用' }, { value: 0, label: '停用' }] }
    ],
    load: () => crm.fields(),
    save: data => crm.saveField(data)
  }
}

export default {
  name: 'CrmRecord',
  components: { CrmDuplicates, CrmOwnerTransfer, CrmPoolSettings, CrmOrderGenerate },
  data() {
    return {
      rows: [],
      poolLeads: [],
      poolCustomers: [],
      keyword: '',
      loading: false,
      saving: false,
      visible: false,
      form: {},
      contracts: [],
      paymentToday: '',
      readonlyPayment: false,
      readonlyApproval: false,
      readonlyActivity: false,
      customerChoices: [],
      dealChoices: [],
      loadSequence: 0,
      taskRecords: {}
    }
  },
  computed: {
    activeFilter() {
      if(this.kind==='deal' && this.$route.query.stage) return '商机阶段：'+labelOf(DEAL_STAGE,this.$route.query.stage)
      if(this.kind==='payment' && this.$route.query.paymentBucket) return '回款分类：'+({PENDING:'待回款（未逾期）',PAID:'已回款',OVERDUE:'逾期回款'}[this.$route.query.paymentBucket] || '')
      return ''
    },
    canApprove() { const u=this.$store.state.user || {}; return ['TENANT_ADMIN','PLATFORM_ADMIN','MANAGER'].some(r=>u.roleCode===r || (u.roleCodes || []).includes(r)) },
    kind() {
      return (this.$route.meta && this.$route.meta.kind) || 'lead'
    },
    title() {
      return (this.$route.meta && this.$route.meta.title) || '记录'
    },
    spec() {
      return SPECS[this.kind] || SPECS.lead
    },
    columns() {
      return this.spec.columns || []
    },
    fields() {
      if(this.kind==='lead')return this.spec.fields.map(f=>f.prop==='status'?{...f,disabled:this.form.status==='CONVERTED',options:LEAD_STATUS.filter(o=>['NEW','NURTURE','CLOSED'].includes(o.value) || o.value===this.form.status)}:f)
      if(['contact','deal'].includes(this.kind))return this.spec.fields.map(f=>f.prop==='customerId'?{...f,filterable:true,options:this.customerOptions}:f)
      if(this.kind==='task' && this.form.taskType==='CRM_DAILY_DIGEST') return this.spec.fields.filter(f=>f.prop==='status')
      if(this.kind==='task')return this.spec.fields.map(f=>f.prop==='bizType'?{...f,clearable:!this.form.id,disabled:!!this.form.id}:f.prop==='bizId'?{...f,filterable:true,disabled:!this.form.bizType || !!this.form.id,options:(this.taskRecords[this.form.bizType] || []).map(r=>({value:r.id,label:(r.title || r.name || '#'+r.id)+'（#'+r.id+'）'}))}:f)
      if(this.kind==='activity')return this.spec.fields.map(f=>f.prop==='bizType'?{...f,clearable:true}:f.prop==='bizId'?{...f,filterable:true,disabled:!this.form.bizType,options:(this.taskRecords[this.form.bizType] || []).map(r=>({value:r.id,label:(r.title || r.name || '#'+r.id)+'（#'+r.id+'）'+(r.inPool?' · 公海，需先领取':''),disabled:!!r.inPool}))}:f)
      if(this.kind==='payment')return this.spec.fields.map(f=>f.prop==='contractId'?{...f,options:this.contracts.map(c=>({value:c.id,label:(c.contractNo || '#'+c.id)+' · '+c.title}))}:f)
      if(this.kind==='contract')return this.spec.fields.map(f=>f.prop==='customerId'?{...f,filterable:true,options:this.customerOptions}:f.prop==='dealId'?{...f,filterable:true,clearable:true,disabled:!this.form.customerId,options:this.dealChoices.filter(d=>d.customerId===this.form.customerId).map(d=>({value:d.id,label:d.title+'（#'+d.id+'）'}))}:f)
      if(this.kind==='approval'){
        const fields=this.spec.fields.map(f=>f.prop==='bizId'?{...f,disabled:!!this.form.id,options:this.contracts.map(c=>({value:c.id,label:(c.contractNo || '#'+c.id)+' · '+c.title}))}:f.prop==='bizType'?{...f,disabled:true}:f)
        return this.form.id?fields.concat([{prop:'status',label:'状态',type:'select',options:APPROVAL_STATUS,disabled:true},{prop:'comment',label:'审批意见',disabled:true},{prop:'decidedAt',label:'处理时间',disabled:true}]):fields
      }
      return this.spec.fields || []
    },
    showKeyword() {
      return this.kind === 'lead' || this.kind === 'customer' || this.kind === 'pool'
    },
    customerOptions() {
      return this.customerChoices.map(c=>({value:c.id,label:c.name+'（#'+c.id+'）'+(c.inPool?' · 公海，需先领取':''),disabled:!!c.inPool}))
    }
  },
  watch: {
    '$route.fullPath'() {
      this.visible = false
      this.readonlyActivity = false
      const loaded = this.load()
      if(this.$route && this.$route.query && (this.$route.query.recordId || this.$route.query.create==='1')) {
        const sequence = this.loadSequence
        const path = this.$route.fullPath
        Promise.resolve(loaded).then(() => { if(sequence===this.loadSequence && path===this.$route.fullPath)this.openRequestedRecord() })
      }
    }
  },
  created() {
    const loaded = this.load()
    if(this.$route.query.recordId || this.$route.query.create==='1') {
      const sequence = this.loadSequence
      const path = this.$route.fullPath
      Promise.resolve(loaded).then(() => { if(sequence===this.loadSequence && path===this.$route.fullPath)this.openRequestedRecord() })
    }
  },
  methods: {
    openRequestedRecord() {
      if(this.$route.query.create==='1') {
        const query=this.$route.query
        if(this.kind==='contact') {
          const id=Number(query.customerId)
          if(!Number.isSafeInteger(id) || id<=0 || !this.customerChoices.some(row=>Number(row.id)===id && !row.inPool))return
          this.open();this.$set(this.form,'customerId',id)
        } else if(this.kind==='task') {
          const type=String(query.bizType || '')
          const id=Number(query.bizId)
          if(!['LEAD','CUSTOMER','DEAL','CONTRACT'].includes(type) || !Number.isSafeInteger(id) || id<=0 || !(this.taskRecords[type] || []).some(row=>Number(row.id)===id && !row.inPool))return
          this.open();this.$set(this.form,'bizType',type);this.$set(this.form,'bizId',id)
        }
        return
      }
      const id = Number(this.$route.query.recordId)
      if(!Number.isSafeInteger(id) || id<=0)return
      const row = this.rows.find(item => Number(item.id)===id)
      if(row)this.open(row)
    },
    selectionChanged(field){
      if(this.kind==='contract' && field.prop==='customerId')this.$set(this.form,'dealId',null)
      if(['task','activity'].includes(this.kind) && field.prop==='bizType')this.$set(this.form,'bizId',null)
    },
    showCell(row, col) {
      if(['task','activity'].includes(this.kind) && col.prop==='bizId'){const record=(this.taskRecords[row.bizType] || []).find(r=>r.id===row.bizId);return record?(record.title || record.name || '#'+record.id):row.bizId?'#'+row.bizId:'—'}
      if(['contact','deal','contract'].includes(this.kind) && col.prop==='customerId'){const customer=this.customerChoices.find(c=>c.id===row.customerId);return customer?customer.name:row.customerId?'#'+row.customerId:'—'}
      if(this.kind==='contract' && col.prop==='dealId'){const deal=this.dealChoices.find(d=>d.id===row.dealId);return deal?deal.title:row.dealId?'#'+row.dealId:'—'}
      if(this.kind==='payment' && col.prop==='contractId'){const contract=this.contracts.find(c=>c.id===row.contractId);return contract?(contract.contractNo || '#'+contract.id)+' · '+contract.title:'#'+row.contractId}
      if(this.kind==='approval' && col.prop==='bizId' && row.bizType==='CONTRACT'){const contract=this.contracts.find(c=>c.id===row.bizId);return contract?(contract.contractNo || '#'+contract.id)+' · '+contract.title:'#'+row.bizId}
      if(this.kind==='payment' && col.prop==='status')return paymentStatusLabel(row,this.paymentToday)
      return col.options ? labelOf(col.options, row[col.prop]) : row[col.prop]
    },
    async load() {
      const sequence = ++this.loadSequence
      const kind = this.kind
      const query = {...this.$route.query}
      this.rows = []
      this.poolLeads = []
      this.poolCustomers = []
      this.customerChoices = []
      this.dealChoices = []
      this.contracts = []
      this.taskRecords = {}
      this.loading = true
      try {
        if (this.kind === 'pool') {
          const [leads, customers] = await Promise.all([
            crm.leads({ inPool: 1, keyword: this.keyword }),
            crm.customers({ inPool: 1, keyword: this.keyword })
          ])
          if(sequence!==this.loadSequence)return
          this.poolLeads = leads.data || []
          this.poolCustomers = customers.data || []
          return
        }
        const paramsNote = this.kind === 'lead'
          ? crm.leads({ inPool: 0, keyword: this.keyword })
          : this.kind === 'customer'
            ? crm.customers({ inPool: 0, keyword: this.keyword })
            : this.spec.load()
        const res = await paramsNote
        if(sequence!==this.loadSequence)return
        if(['task','activity'].includes(kind)){
          const result=await Promise.all([crm.leads(),crm.customers(),crm.deals(),crm.contracts()])
          if(sequence!==this.loadSequence)return
          this.taskRecords=Object.fromEntries(['LEAD','CUSTOMER','DEAL','CONTRACT'].map((type,i)=>[type,result[i].data || []]))
        }
        if(kind==='payment'){
          const [contracts,overview]=await Promise.all([crm.contracts(),crm.analytics()])
          if(sequence!==this.loadSequence)return
          this.contracts=contracts.data || [];this.paymentToday=overview.data.asOfDate
        }
        if(kind==='approval'){
          const contracts=await crm.contracts()
          if(sequence!==this.loadSequence)return
          this.contracts=contracts.data || []
        }
        if(['contact','deal','contract'].includes(kind)){
          const [customers,deals]=await Promise.all([crm.customers(),kind==='contract'?crm.deals():Promise.resolve({data:[]})])
          if(sequence!==this.loadSequence)return
          this.customerChoices=customers.data || [];this.dealChoices=deals.data || []
        }
        this.rows = res.data || []
        if(kind==='deal' && query.stage) this.rows=this.rows.filter(row=>row.stage===query.stage)
        if(kind==='payment' && query.paymentBucket) {
          const today=this.paymentToday
          const bucket=query.paymentBucket
          this.rows=this.rows.filter(row=>{
            const status=effectivePaymentStatus(row,today)
            return bucket==='OVERDUE'?status==='OVERDUE':bucket==='PAID'?status==='PAID':status==='PENDING'
          })
        }
      } finally {
        if(sequence===this.loadSequence)this.loading = false
      }
    },
    open(row) {
      this.readonlyActivity=!!(this.kind==='activity' && row)
      this.readonlyPayment=!!(this.kind==='payment' && row && row.status==='PAID')
      this.readonlyApproval=!!(this.kind==='approval' && row && row.status!=='PENDING')
      this.form = row ? { ...row } : this.kind==='approval'?{bizType:'CONTRACT'}:this.kind==='contract'?{customerId:null,dealId:null,status:'ACTIVE'}:this.kind==='task'?{status:'OPEN',taskType:'FOLLOW_UP',bizType:null,bizId:null,dueAt:null}:{}
      this.visible = true
      if(this.kind==='activity' && !row)this.form={bizType:null,bizId:null,channel:'NOTE',content:''}
    },
    async save() {
      if(['lead','customer'].includes(this.kind) && (!this.form.name || !this.form.name.trim() || this.form.name.trim().length>128)){
        this.$message.warning(this.kind==='lead'?'请填写128字以内的线索姓名':'请填写128字以内的客户名称');return
      }
      if(this.kind==='deal'){
        if(!this.form.title || !this.form.title.trim() || this.form.title.trim().length>128){this.$message.warning('请填写128字以内的商机名称');return}
        const amount=this.form.amount
        if(amount!=null && amount!=='' && (!/^\d+(\.\d{1,2})?$/.test(String(amount)) || Number(amount)>999999999999.99)){this.$message.warning('商机金额须为非负数，最多两位小数');return}
      }
      if(this.kind==='contact'){
        if(!this.form.customerId){this.$message.warning('请选择联系人所属客户');return}
        if(!this.form.name || !this.form.name.trim() || this.form.name.trim().length>64){this.$message.warning('请填写64字以内的联系人姓名');return}
      }
      if(this.readonlyActivity)return
      if(this.kind==='activity'){
        if(!this.form.content || !this.form.content.trim() || this.form.content.length>1000){this.$message.warning('请填写1000字以内的跟进内容');return}
        if(!!this.form.bizType!==!!this.form.bizId){this.$message.warning('请选择完整的对象和关联记录，或均留空');return}
      }
      if(this.kind==='task' && this.form.taskType!=='CRM_DAILY_DIGEST'){
        if(!this.form.title || !this.form.title.trim() || this.form.title.trim().length>128){this.$message.warning('请填写128字以内的提醒标题');return}
        if(!!this.form.bizType!==!!this.form.bizId){this.$message.warning('请选择完整的对象和关联记录，或均留空');return}
      }
      this.saving = true
      try {
        await this.spec.save(this.kind==='contract'?{...this.form,clearDeal:!this.form.dealId}:this.form)
        this.visible = false
        this.$message.success('已保存')
        const returnTo=this.$route.query.create==='1' ? this.$route.query.returnTo : null
        if(typeof returnTo==='string' && /^\/crm\/detail\/(lead|customer|deal|contract)\/\d+$/.test(returnTo)) {
          this.$router.replace({path:returnTo,query:{tab:this.kind==='contact'?'contact':'task'}})
        } else if(this.$route.query.create==='1') {
          this.$router.replace({path:this.$route.path})
        } else this.load()
      } finally {
        this.saving = false
      }
    },
    async act(name, row) {
      await crm[name](row.id)
      this.$message.success('已处理')
      this.load()
    },
    async decide(row, status) {
      let comment=''
      try{const result=await this.$prompt(status==='APPROVED'?'填写审批意见（可留空）':'填写驳回原因（可留空）',status==='APPROVED'?'通过审批':'驳回审批',{customClass:'crm-approval-decision',inputType:'textarea',inputValidator:value=>!value || value.length<=500 || '审批意见不能超过500字'});comment=result.value || ''}catch(e){return}
      await crm.decideApproval(row.id, { status, comment,version:row.version })
      this.$message.success('已处理')
      this.load()
    }
  }
}
</script>

<style>
.crm-record-dialog, .crm-approval-decision { max-width: calc(100vw - 24px); }
.crm-record-dialog { display: flex; flex-direction: column; max-height: calc(85vh - 24px); }
.crm-record-dialog > .el-dialog__body { min-height: 0; overflow-y: auto; }
.crm-record-dialog > .el-dialog__header, .crm-record-dialog > .el-dialog__footer { flex-shrink: 0; }
@media (max-height: 720px) {
  .crm-record-dialog { margin-top: 16px !important; max-height: calc(100vh - 32px); }
}
</style>
